import { Component, computed, effect, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';

import { ModalLayoutComponent } from '@shared/lib/components';
import { ICourse } from '@shared/lib/interfaces';
import { DerivedAuthService, SalesforceService } from '@shared/lib/services';
import { environment } from 'projects/portal/src/environments/environment';

@Component({
  selector: 'wu-render-affirm-reg',
  imports: [ModalLayoutComponent],
  templateUrl: './render-affirm-reg.component.html',
  styleUrl: './render-affirm-reg.component.scss',
})
export class RenderAffirmRegComponent {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly derivedAuthService = inject(DerivedAuthService);
  private readonly salesforceService = inject(SalesforceService);

  private readonly fragmentSignal = toSignal(this.activatedRoute.fragment);
  private hasFetched = false;

  readonly modalIsOpened = computed(() => {
    return this.fragmentSignal() === 'confirm-registration';
  });

  readonly registeredCourses = signal<ICourse[]>([]);
  readonly unregisteredCourses = signal<ICourse[]>([]);
  readonly alreadyRegisteredCourses = signal<ICourse[]>([]);

  readonly studentId = this.derivedAuthService.studentId;
  readonly hasError = signal(false);
  readonly isLoading = signal(false);
  readonly SSB_REGISTRATION = environment.ssbRegistrationURL;

  constructor() {
    effect(() => {
      if (!this.modalIsOpened()) {
        this.hasFetched = false;
        return;
      }

      const studentId = this.studentId();

      if (!this.hasFetched) {
        if (studentId) {
          this.getBatchcoursereg(studentId);
          this.hasFetched = true;
        } else {
          const id = localStorage.getItem('studentId');
          if (id) {
            this.getBatchcoursereg(id);
            this.hasFetched = true;
          } else {
            console.warn('StudentId not available yet');
          }
        }
      }
    });
  }

  private mapCourses(courses: ICourse[]) {
    this.alreadyRegisteredCourses.set(
      courses.filter(course => course.affirmedFlag === 'N' && !course.reason),
    );
    this.registeredCourses.set(courses.filter(course => !course.reason));
    this.unregisteredCourses.set(courses.filter(course => course.reason));
  }

  getBatchcoursereg(studentId?: string) {
    const body = {
      studentId: studentId || this.studentId()!,
      origin: 'STUDENTPORTAL',
    };
    this.isLoading.set(true);
    this.salesforceService
      .batchcourseregrequest(body, environment.unifiedPortalGraphQlUrl)
      .subscribe({
        next: (response: any) => {
          this.mapCourses(response);
          this.isLoading.set(false);
        },
        error: (error: any) => {
          this.hasError.set(true);
          this.isLoading.set(false);
        },
      });
  }

  /**
   * Close the modal by clearing the fragment and reloading the page
   */
  closeModal(): void {
    void this.router.navigate(['/dashboard'], { fragment: '' }).then(() => {
      // Reload the page after navigation
      window.location.reload();
    });
  }
}
